import './nav-drawer.scss';

import { Button, ConfigProvider, Drawer, theme as antdTheme } from 'antd';
import { useTranslation } from 'react-i18next';

import { CloseOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';
import { getPalette } from '@/styles/palette';

import { NAV_DRAWER_WIDTH } from '../../constants';
import NavMenu from '../../entities/nav-menu';
import BrandLogo from '../../ui/brand-logo';

interface IProps {
  open: boolean;
  onClose: () => void;
}

/** Разделы кабинета на среднем и узком экране: выезжают слева по бургеру. */
const NavDrawer: React.FC<IProps> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const theme = useAppSelector((state) => state.app.theme);
  const palette = getPalette(theme);

  return (
    // Подложка drawer — тёмная в обеих схемах: тёмный алгоритм делает кнопки и иконки светлыми.
    <ConfigProvider
      theme={{
        algorithm: antdTheme.darkAlgorithm,
        token: {
          colorBgElevated: palette.siderBg,
          colorText: palette.siderTextStrong,
          colorIcon: palette.siderText,
          colorIconHover: palette.siderTextStrong,
          colorBgTextHover: palette.siderHover
        }
      }}
    >
      <Drawer
        open={open}
        onClose={onClose}
        placement="left"
        size={`min(100%, ${NAV_DRAWER_WIDTH}px)`}
        closable={false}
        classNames={{ body: 'nav-drawer' }}
        styles={{ body: { padding: 0 } }}
        aria-label={t('layout.nav.label')}
      >
        <div className="nav-drawer__head">
          <BrandLogo inverse onClick={onClose} />
          <Button
            type="text"
            icon={<CloseOutlined />}
            aria-label={t('layout.nav.close')}
            onClick={onClose}
          />
        </div>
        <NavMenu onNavigate={onClose} />
      </Drawer>
    </ConfigProvider>
  );
};

export default NavDrawer;
